"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readPackageJson = readPackageJson;
var _types = require("../types");
var _readFile = require("./readFile");
async function readPackageJson(path, options) {
  return (0, _readFile.readFile)(path, _types.packageJsonSchema, options);
}
